/**
 * 级联筛选器
 * 统一叫法：左侧叫Group，右侧叫child
 * 目前应用是指标筛选器，左侧是数据源，右侧是指标
 */

import React from 'react';
import { Dropdown, Checkbox } from 'tea-component';
import SingleMenuItem from './Cascader/SingleMenuItem';
import DisplaySingleValue from './Cascader/DisplaySingleValue';
import DisplayEmpty from './Cascader/DisplayEmpty';
import DisplayNormal from './Cascader/DisplayNormal';
import { IMutipleSelectorProps, IChildProp } from '../../type';
import './Cascader/index.scss';

export default function MutipleSelector(props: IMutipleSelectorProps) {
  // console.log(props);
  const { options = [], value, field, onChange, groupName = 'Metrics', width = 250 } = props;

  /**
   * 点击清空时的回调
   */
  const handleClear = () => {
    if (onChange instanceof Function) {
      onChange(field, []);
    }
  };


  /**
   * 选项发生变化时的回调
   * @param key 触发的某一项的key名
   * @param formItemChecked 选中还是未选中
   * @param formItem 这一项的配置
   */
  const handleChange = (key: string, formItemChecked: boolean) => {
    const selectedList = JSON.parse(JSON.stringify(value)) || [];
    if (formItemChecked) {
      selectedList.push(key);
    } else {
      if (selectedList.length === 1) return;
      const findIndex = selectedList.findIndex((selected: string) => selected === key);
      // 最后一个不能清除
      if (findIndex !== -1) {
        selectedList.splice(findIndex, 1);
      }
    }
    onChange(field, selectedList);
  };

  /**
   * 输入框显示的渲染函数
   * 当只有一个时显示”指标icon+指标名“
   * 当某个数据源中指标被全部选中，且没有存在部分选中的情况，显示Metrics Category
   * 当数据源存在部分选中的情况，显示Metrics
   * 否则显示空态
   * @returns 
   */
  const displayRender = () => {
    const selectedLen = value?.length || 0;
    // 单个的选择
    if (selectedLen === 1) {
      const showItem: IChildProp = options.find(item => item.value === value[0]) || [];
      return <DisplaySingleValue showItem={showItem} />;
    }
    // 全选
    if (options?.length === selectedLen) {
      return (<DisplayNormal groupName={groupName} showLabel={'All'}/>);
    }
    if (selectedLen > 0) {
      return (<DisplayNormal groupName={groupName} showLabel={selectedLen}/>);
    }
    // 空态
    return (<DisplayEmpty />);
  };

  return (
    <Dropdown
      className="dbi-regionselecter dbi-regionselecter--secondary"
      clearable={!!value}
      button={displayRender()}
      appearance="button"
      clickClose={false}
      onClear={handleClear}
    >
      {() => (
        <div className="dbi-regionselecter-content">
          <div className="dbi-regionselecter-content-wrap" style={{width: `${width}px`}}>
            <div className="dbi-regionselecter-checkbox tea-list--option">
              <Checkbox.Group>
                {
                  options?.map((item) => (<SingleMenuItem
                    key={item.value}
                    formItem={item}
                    formValue={value}
                    isMutiple={true}
                    onChange={handleChange}
                  />))
                }
              </Checkbox.Group>
            </div>
          </div>
        </div>
      )}
    </Dropdown>
  );
}